<p>{{message | titlecase}}</p>
